import { __assign, __awaiter, __generator } from "tslib";
import { useMemo } from 'react';
import { Auth } from 'aws-amplify';
import { authProvider } from './setup-auth-provider';
export function useServices(toSignIn) {
    return useMemo(function () { return ({
        handleSignUp: handleSignUp,
        handleSignIn: handleSignIn,
        handleConfirmSignUp: function (_a) {
            var username = _a.username, code = _a.code;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Auth.confirmSignUp(username, code, {
                                clientMetadata: {
                                    env: authProvider.env,
                                },
                            })];
                        case 1:
                            _b.sent();
                            // By redirecting to SignIn form we provide more time
                            // for the user registration process to finish.
                            toSignIn();
                            return [2 /*return*/];
                    }
                });
            });
        },
    }); }, [toSignIn]);
}
function handleSignUp(
// @aws-amplify/ui-react does not export type for formData.
formData) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var response, error_1, isUnknownDomain;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Auth.signUp({
                            username: formData.username,
                            password: formData.password,
                            attributes: formData.attributes,
                            clientMetadata: __assign(__assign({}, formData === null || formData === void 0 ? void 0 : formData.clientMetadata), { env: authProvider.env }),
                            autoSignIn: {
                                enabled: false,
                            },
                        })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_1 = _c.sent();
                    isUnknownDomain = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.message) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, 'Unknown email address domain');
                    if (isUnknownDomain) {
                        // By re-throwing trigger errors we avoid the default prefix of "PreSignUp:.."
                        throw new Error('Unknown email address domain.');
                    }
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function handleSignIn(_a) {
    var _b, _c;
    var username = _a.username, password = _a.password;
    return __awaiter(this, void 0, void 0, function () {
        var response, error_2, isNotFoundError;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Auth.signIn(username, password, {
                            env: authProvider.env,
                        })];
                case 1:
                    response = _d.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_2 = _d.sent();
                    isNotFoundError = (_c = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.message) === null || _b === void 0 ? void 0 : _b.includes) === null || _c === void 0 ? void 0 : _c.call(_b, 'User not found');
                    if (isNotFoundError) {
                        // By re-throwing trigger errors we avoid the default prefix of "PreAuthentication:.."
                        throw new Error('User not found. If you just signed-up your user, please try again.');
                    }
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    });
}
